import { Action, createReducer, on } from '@ngrx/store';
import { IAVCFrequencyResponse } from '../models/avc-frequency.model';
import { fromStaticDataAVCFrequenciesAction } from '../actions';

export const avcFrequenciesFeatureKey = 'getAVCFrequencies';

export interface AVCFrequencyState {
  loadAVCFrequencyResponse: IAVCFrequencyResponse[];
  loadAVCFrequencyFailure: Error | any;
}

export const initialState: AVCFrequencyState = {
  loadAVCFrequencyResponse: undefined,
  loadAVCFrequencyFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromStaticDataAVCFrequenciesAction.loadAVCFrequenciesSuccess, (state, action) => ({
    ...state,
    loadStaticDataAVCFrequenciesResponse: action.response
  }))
);

export const getAVCFrequencies = (state: AVCFrequencyState) => {
  if (state && state.loadAVCFrequencyResponse) return JSON.parse(JSON.stringify(state.loadAVCFrequencyResponse));
  else return null;
};
